// src/components/LandingHeader.jsx
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/components/LandingHeader.scss';

const LandingHeader = ({ showNavButton = true }) => {
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    const handleGetStarted = () => {
        if (currentUser) {
            // ログイン済みの場合はダッシュボードへ
            navigate(`/dashboard/${currentUser.uid}`);
        } else {
            // 未ログインの場合はログインページへ
            navigate('/login');
        }
    };

    return (
        <header className="landing-header">
            <div className="container">
                <div className="header-content">
                    <div className="logo">
                        <Link to="/" className="logo-link">
                            <h1>Suisui</h1>
                        </Link>
                    </div>
                    {showNavButton && (
                        <nav className="header-nav">
                            <button
                                onClick={handleGetStarted}
                                className="cta-button"
                            >
                                {currentUser ? 'ダッシュボード' : '始める'}
                            </button>
                        </nav>
                    )}
                </div>
            </div>
        </header>
    );
};

export default LandingHeader;
